import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  CircularProgress,
  TableFooter,
} from "@mui/material";
import TablePaginationMy from "../table-pagination/table-pagination";

function TableWrapper({
  tableStyle,
  containerStyle,
  spanTd,
  message,
  isLoading,
  isContent,
  children,
  thContent,
  pagination,
  onChangePage,
  onChangeRowsPerPage,
  page,
  rowsPerPage,
  perPage,
  total,
  showPagination,
  ...props
}) {
  return (
    <TableContainer sx={containerStyle}>
      <Table
        sx={[
          tableStyle,
          {
            "& .MuiTableCell-root": {
              paddingTop: "10px",
              paddingBottom: "10px",
              border: 1,
              borderColor: "lightgray",
            },
          },
        ]}
        {...props}
      >
        <TableHead>
          <TableRow
            sx={{
              "& th": {
                padding: { sm: "15px !important", xs: "10px !important" },
                fontWeight: "bold",
              },
            }}
          >
            {thContent}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={spanTd} align="center">
                <CircularProgress size={22} />
              </TableCell>
            </TableRow>
          ) : isContent ? (
            children
          ) : (
            <TableRow>
              <TableCell colSpan={spanTd} align="center">
                <Typography variant="caption1">
                  {!!message ? message : "No Records Found"}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>

        <TableFooter>
          {pagination}
          {showPagination && (
            <TablePaginationMy
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              perPage={perPage || 0}
              total={total || 0}
            />
          )}
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
TableWrapper.defaultProps = {
  tableStyle: {},
  spanTd: "1",
  message: null,
  isContent: false,
  isLoading: false,
};
export default TableWrapper;
